import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import { Form, Formik, useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";
import ReactCodeInput from "react-code-input";
import { useVerifyMutation } from "../../../../features/api/Api";
import { useAppDispatch } from "../../../../app/hooks";
import { setCredentials } from "../../../../features/auth/AuthSlice";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

interface IProps {
  open: boolean;
  phoneNumber: string;
  message: string
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const VerifyDialog: FC<IProps> = ({ open, message, phoneNumber }) => {
  const [counter, setCounter] = useState(120);
  const [initialCounter, setInitialCounter] = useState(120);
  const [codeVerify, setCodeVerify] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<any>(null);


  const formik: any = useFormikContext();
  const [verify, { isLoading }] = useVerifyMutation();
  const dispatch = useAppDispatch();
  const history = useNavigate();

  useEffect(() => {
    let interval: any = null;

    if (counter > 0) {
      interval = setInterval(() => {
        setCounter((c) => c - 1);
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [counter]);

  const handleCode = () => {
    const val = {
      code: codeVerify,
      customerCode: formik.values.customerCode,
      email: formik.values.email,
      clientId: "Bayi",
    };

    verify(val)
      .unwrap()
      .then((data: any) => {
        const receivedMessage = data?.data?.message;
        if (receivedMessage) {
          setCounter(300); // Start the timer with 5 minutes if message is present in the data
          setInitialCounter(300);
        } else {
          setCounter(120); // Otherwise, start with 120 seconds
          setInitialCounter(120);
        }
        setErrorMessage(receivedMessage);
        dispatch(setCredentials(data.data));
        history("/");
      })
      .catch((error) => {
        const message = error.response?.data?.message || error?.data?.errors || "Lütfen Bekleyiniz.";
        setErrorMessage(error?.data?.errors[0] || message);



        Swal.fire({
          icon: "error",
          title: "Değerli Müşterimiz,",
          text: message,
        });
      });
    setCodeVerify("")
  };

  const showAgainBtn = counter <= 0;

  // Calculate minutes and seconds from counter
  const minutes = Math.floor(counter / 60);
  const seconds = counter % 60;

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Formik initialValues={{ code: "" }} onSubmit={handleCode}>
        {({ values, handleChange }) => (
          <Form>
            <Box sx={style}>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {!isLoading ? (
                  <>
                    {showAgainBtn ? (
                      <Button
                        variant="outlined"
                        fullWidth
                        onClick={() => {
                          history("/");
                        }}
                      >
                        TEKRAR GÖNDER
                      </Button>

                    ) : (
                      <>
                        <Typography sx={{ textAlign: "center" }}>
                          <strong>{phoneNumber}</strong> numaralı cep telefonuna
                          kod gönderilmiştir.
                        </Typography>
                        <Typography
                          sx={{ textAlign: "center" }}
                          variant="h6"
                          component="h2"
                        >
                          {errorMessage ? (
                            <>
                              {errorMessage}  <br />
                              {initialCounter === 300 && (
                                <>
                                  {minutes > 0
                                    ? `Kalan süre: ${minutes} dakika ${seconds} saniye`
                                    : `Kalan süre: ${seconds} saniye`}
                                </>
                              )}
                              {errorMessage.startsWith("Girilen") && (
                                <>
                                  {`Kalan süre ${counter}`}
                                </>
                              )}
                            </>
                          ) : (
                            `Lütfen gelen kodu ${counter} saniye içerisinde giriniz.`
                          )}
                        </Typography>
                        {(initialCounter !== 300) && (counter > 0) && (
                          <div>
                            <ReactCodeInput
                              type="text"
                              name="code"
                              value={codeVerify}
                              fields={6}
                              inputMode="numeric"
                              onChange={(e: any) => setCodeVerify(e)}
                            />

                            <Button
                              variant="outlined"
                              color="primary"
                              sx={{ marginTop: "30px", width: "100%" }}
                              type="submit"
                              disabled={(codeVerify?.length !== 6) || (initialCounter === 300 && counter > 0)}
                            >
                              GÖNDER
                            </Button>
                          </div>
                        )}
                      </>

                    )}
                  </>
                ) : (
                  <CircularProgress />
                )}
              </Typography>
            </Box>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default VerifyDialog;
